export default __webpack_public_path__ + "static/media/note-size_h2.e28a64c3.svg";